// extracted by mini-css-extract-plugin
export default {"service":"Service_service__5cMUw","icon":"Service_icon__5qZZx","title":"Service_title__swUuT","description":"Service_description__Q0qb4"};